<template>
    <v-app :style="{'font-family': font}">

        <edit-menu v-if="$root.edit && $store.state.editMenu" />

        <component-wrapper :key="$vuetify.application.left + '|' + $vuetify.application.right"
                           :style="{left: $vuetify.application.left + 'px', right: $vuetify.application.right  + 'px', position: 'relative', top: $root.edit && $store.state.editMenu ? '48px' : '0px'}"
                           :config="$root.siteconfig.appbar"
        />

        <edit-panel v-if="$root.edit && !$store.state.editMenu && !isInIframe" :selectedcomponent="$root.selectedEditComponent" ref="editpanel" />

        <div v-if="!isInIframe && $root.edit && $root.mobilePreview">
            <iframe
                ref="mobilePreview"
                style="position: absolute; left: calc(25% + 75%/2 - 375px/2); top: 200px; width: 375px; height: 700px; border: 1px solid black; z-index: 100"
                :src="thisHref"
                @load="mobilePreviewLoaded"
            ></iframe>
            <component-wrapper
                style="position: absolute; left: calc(25% + 75%/2 - 375px/2); top: 900px; width: 375px; height: 56px; z-index: 100; opacity: 0"
                :config="$root.siteconfig.bottombar"/>
        </div>

        <div v-if="!isInIframe && $root.edit && $root.revisionPreview !== null">
            <div style="margin-left: 460px" class="d-flex my-4">
                <div class="d-flex flex-column ml-4">
                    <div class="headline">{{$translate('Here below version {0} is shown').format($root.revisionPreview.id)}}</div>
                    <div>{{$root.revisionPreview.created}}, {{$root.revisionPreview.author}}</div>
                </div>

                <v-btn class="mx-8" @click="$root.revertToRevision($root.revisionPreview.id)" color="error">{{$translate('Restore to this version')}}<v-icon>mdi-restore</v-icon></v-btn>
                <v-btn color="primary" @click="$root.revisionPreview = null">{{$translate('Return to current version')}}</v-btn>
            </div>
            <iframe
                :key="revisionRenderKey"
                style="position: absolute; left: 460px; top: 80px; width: calc(100% - 460px); height: 100vh; border: none; z-index: 100"
                v-if="!isInIframe && $root.edit && $root.revisionPreview !== null"
                :src="thisHref + '?revision_id=' + $root.revisionPreview.id"
            ></iframe>
        </div>

        <v-main
            v-show="!$root.mobilePreview && $root.revisionPreview == null"
            :class="{'ma-0': $root.siteconfig.appbar.props.transparent && !$root.edit, 'pa-0': $root.siteconfig.appbar.props.transparent && !$root.edit}"
        >
            <router-view />

            <edit-popover v-if="$root.edit && $store.state.editMenu && $store.state.editComponent" :component="$store.state.editComponent" />

            <v-footer v-if="showFooter" padless :key="footerRenderKey">
                <v-card v-if="$root.edit" width="100%" @click="$store.commit('setEditComponent', $refs.footer.$children[0])" flat tile>
                    <v-card-title class="headline zoezi-edit-color">{{$translate('Footer')}}</v-card-title>
                </v-card>

                <component-wrapper
                    ref="footer"
                    :config="$root.siteconfig.footer"
                    style="width: 100%"
                />
            </v-footer>

            <!-- Outside the footer: customers can hide or replace it, but the way back to the cookie choice must stay. -->
            <div v-if="cookieConsentEnabled && $root.siteconfig.cookieBar && $root.siteconfig.cookieBar.component == 'zoezi-cookie-bar'" class="text-center text-caption py-2" :style="{marginBottom: cookieLinkBottomMargin}">
                <span class="z-clickable text-decoration-underline" role="button" tabindex="0" @click="$root.$emit('openCookieSettings')" @keydown.enter.prevent="$root.$emit('openCookieSettings')" @keydown.space.prevent="$root.$emit('openCookieSettings')">{{ $translate('Cookie settings') }}</span>
            </div>

            <component-wrapper :config="$root.siteconfig.cookieBar" />

            <v-btn v-if="!$root.edit && !isInIframe && hasEditPermission && !noEditMode && !isExpoApp()"
                   @click="$root.setEditMode()"
                   :loading="$store.state.editModeInitializing"
                   color="zoezi-edit-color"
                   fab
                   bottom
                   left
                   fixed
                   style="z-index: 20;"
                   :style="{bottom: floatingButtonBottom}"
            >
                <v-icon>mdi-cog</v-icon>
            </v-btn>

            <v-btn v-if="showBookedBall && numBookings"
                   @click="gotoMyPages"
                   color="primary"
                   fab
                   bottom
                   right
                   fixed
                   :style="{bottom: floatingButtonBottom}"
            >
                <v-badge :key="numBookings" :content="numBookings" color="red" :value="numBookings" class="animate__animated animate__heartBeat" left>
                    <v-icon :style="{color: $root.siteconfig.appbar.props.color}">mdi-ticket</v-icon>
                </v-badge>
            </v-btn>

            <mobile-menu :showCheckinButton="$root.siteconfig.appbar.props.showCheckinButton" :checkinResources="$root.siteconfig.appbar.props.checkinResources" :showStaffButton="$root.siteconfig.appbar.props.showStaffButton" />

            <!--      <v-navigation-drawer
      :value="$store.state.showMobileMenu"
      @input="$store.commit('setShowMobileMenu', $event)"
      disable-route-watcher
      disable-resize-watcher
      app
      :right="true"
      :width="$root.siteconfig.appbar.props.fullWidth ? '100%' : ''"
      :color="$root.siteconfig.appbar.props.backgroundColor"
      :src="$root.siteconfig.appbar.props.transparent ? undefined : $api.getImageUrl($root.siteconfig.appbar.props.backgroundImage)"
      hide-overlay
      style="z-index: 5; bottom: 0; top: unset"
      height="50vh"
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group>
           <component-wrapper
              v-for="button in $root.siteconfig.buttons"
              :key="button.id"
              :config="button"
              can-remove
            />
        </v-list-item-group>

      </v-list>
     </v-navigation-drawer> -->
        </v-main>

        <component-wrapper v-if="$vuetify.breakpoint.mobile"
                           :config="$root.siteconfig.bottombar"
        />

        <error-dialog />
        <snack-bar />

        <missing-member-fields />

        <shopping-cart/>

        <checkout-done-dialog />

        <add-user-dialog />

        <change-user-dialog />

        <portal-target name="toolbox" multiple />

        <confirm-dialog />

        <adyen-redirect />

        <epassi-redirect />

        <save-card-dialog />

        <checkin-dialog v-if="$store.state.user" v-model="$store.state.checkinDialog.show" :resources="$store.state.checkinDialog.resources" :onlyShowQrScanner="$store.state.checkinDialog.onlyShowQrScanner" :allSites="$store.state.checkinDialog.allSites" />
        <invalid-cart-dialog v-model="$store.state.invalidCartDialog.show"/>
        <group-invite-dialog v-if="showGroupInviteDialog" />
        <withdrawal-link-dialog v-if="showWithdrawalLinkDialog" />
    </v-app>
</template>

<script>
import {merge, debounce} from 'lodash'
import SnackBar from './SnackBar.vue'
import MissingMemberFields from './MissingMemberFields.vue'
import MobileMenu from './MobileMenu.vue'
import ShoppingCart from '../views/ShoppingCart.vue';
import CheckoutDoneDialog from '../views/CheckoutDoneDialog.vue'
import AddUserDialog from '../views/AddUserDialog.vue'
import ChangeUserDialog from '../views/ChangeUserDialog.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'
import AdyenRedirect from '../components/AdyenRedirect.vue'
import SaveCardDialog from '../components/SaveCardDialog.vue'
import { getUrlParameterThis, isExpoApp, isCookieConsentEnabled } from '../util.js'
import CheckinDialog from './CheckinDialog.vue'
import GroupInviteDialog from '../views/GroupInviteDialog.vue';
import WithdrawalLinkDialog from '../views/WithdrawalLinkDialog.vue';
import EpassiRedirect from './EpassiRedirect.vue'
import InvalidCartDialog from './InvalidCartDialog.vue';

export default {
    name: 'zoezi-root',

    zoezi: {
        title: 'Root',
        icon: 'mdi-file-tree-outline',
        internal: true
    },
    props: {
        name: {
            type: String,
            title: 'Homepage name'
        },
        title: {
            type: String,
            title: 'Browser title'
        },
        favicon: {
            type: String,
            title: 'Favicon',
            fulltype: 'image'
        },
        showFooter: {
            type: Boolean,
            title: 'Show footer'
        },
        showBookedBall: {
            type: Boolean,
            default: true,
            title: 'Show icon for active bookings'
        },
        font: {
            type: String,
            title: 'Font',
            fulltype: 'font'
        },
        colors: {
            type: Object,
            title: 'Primary colors',
            fulltype: 'colortheme'
        },
        cookieBar: {
            type: Object,
            title: 'Cookie dialog',
            fulltype: 'component',
            typeinfo: {
                clearable: true
            }
        },
        gtm: {
            type: String,
            title: 'Google Tagmanager ID',
            section: 'Tracking'
        },
        ga4: {
            type: String,
            title: 'Google Analytics 4 ID',
            section: 'Tracking'
        },
        pixel: {
            type: String,
            title: 'Meta Pixel ID',
            section: 'Tracking'
        },
        domainname: {
            type: String,
            title: 'Domain name'
        }
    },

    data: () => ({
        footerRenderKey: 0,
        mobileRenderKey: 0,
        revisionRenderKey: 0,
        debouncedUndo: null,
        debouncedRedo: null,
        cookieBarHeight: 0
    }),
    components: {
        SnackBar,
        MissingMemberFields,
        MobileMenu,
        ShoppingCart,
        CheckoutDoneDialog,
        AddUserDialog,
        ChangeUserDialog,
        ConfirmDialog,
        AdyenRedirect,
        SaveCardDialog,
        CheckinDialog,
        GroupInviteDialog,
        WithdrawalLinkDialog,
        EpassiRedirect,
        InvalidCartDialog
    },
    watch: {
        '$root.siteconfig': {
            deep: true,
            handler(siteconfig) {
                let iframe = this.$refs.mobilePreview;
                if (this.$root.edit && iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage({action: 'setSiteConfig', data: siteconfig});
                }
            }
        },
        font() {
            this.$root.loadFont(this.font);
        },
        title() {
            this.$root.setTitle();
        },
        '$root.revisionPreview'() {
            this.revisionRenderKey++;
        },
        '$store.state.isLoggedIn'(isLoggedIn) {
            if (!isLoggedIn) {
                // FIXME: If we have logged out from within resource booking we don't want to navigate away
                //this.goto('/');
                console.log('Should goto /')
            }
        },
        '$store.state.editComponent'() {
            if (this.isInIframe) {
                console.log('Postmessage of setEditComponent for id ' + this.$store.state.editComponentConfig?.id )
                window.top.postMessage({action: 'setEditComponent', data: this.$store.state.editComponentConfig?.id });
            }
        }
    },
    computed: {
        cookieConsentEnabled() {
            return isCookieConsentEnabled();
        },
        // The global CSS only keeps content clear of the fixed bottom bar up to 959px, but the bar shows whenever Vuetify says mobile.
        cookieLinkBottomMargin() {
            return this.$vuetify.breakpoint.mobile && this.$vuetify.breakpoint.width > 959 ? '56px' : undefined;
        },
        // Fixed buttons sit above the cookie bar while it is shown, so they do not cover its text or choices.
        floatingButtonBottom() {
            const bottomBar = this.$vuetify.breakpoint.mobile ? 56 : 0;
            return `${bottomBar + 16 + this.cookieBarHeight}px`;
        },
        showGroupInviteDialog() {
            const groupInviteQuery = this.$root.siteconfig.pages.mypagesGroupInvite || 'groupinvite';
            return !!this.$route.query[groupInviteQuery];
        },
        showWithdrawalLinkDialog() {
            return this.$api.hasFlag('flag-withdrawal-request') && !!this.$route.query.withdraw;
        },
        isInIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        thisHref() {
            return window.location.protocol + '//' + window.location.host + window.location.pathname;
        },
        noEditMode() {
            return !!getUrlParameterThis('noeditmode');
        },
        hasEditPermission() {
            return this.$store.state.isLoggedIn && this.$store.state.user && !!this.$store.state.user.permissions.find(x => x == 'Change homepage') && this.$store.state.settings && (this.$store.state.settings.zoeziMyBusiness == 'flex' || (this.$store.state.settings.zoeziMyBusiness == 'basic' && this.$store.state.user.superUser));
        },
        numBookings() {
            let b = this.$store.getters.comingBookings;
            if (!b) {
                return 0;
            }

            let res = 0;
            if (b.workouts) {
                res += b.workouts.length;
            }

            if (b.resourcebookings) {
                res += b.resourcebookings.length
            }

            if (b.coursebookings) {
                res += b.coursebookings.length;
            }

            return res;
        }
    },
    methods: {
        isExpoApp,
        setCookieBarHeight(height) {
            this.cookieBarHeight = height;
        },
        mobilePreviewLoaded() {
            this.$root.mobilePreviewLoading = false;
        },
        goto(link) {
            if (this.$route.path != link) {
                this.$router.push({path: link});
            }
        },
        gotoMyPages() {
            let link = this.$root.getDefaultPage('mypages');
            if (this.$route.path != link) {
                this.goto(link);
            } else {
                this.$vuetify.goTo(0);
            }
        },
        fetchAndProcessRevisions(action) {
            if (!this.$root.edit) {
                return;
            }
            this.$api.get('/api/homepage/revision/get', {homepage_id: this.$root.homepage_id})
                .then(data => {
                    const revisions = data;
                    const revision_id = this.$root.revisionPreview ? this.$root.revisionPreview.id : this.$root.current_revision_id;
                    const currentRevisionIndex = revisions.findIndex(rev => rev.id == revision_id);

                    if (action === 'undo' && currentRevisionIndex < revisions.length - 1) {
                        this.$root.revisionPreview = revisions[currentRevisionIndex + 1];
                    } else if (action === 'redo') {
                        this.$root.revisionPreview = currentRevisionIndex > 0 ? revisions[currentRevisionIndex - 1] : null;
                    }
                });
        },
        undo() {
            this.fetchAndProcessRevisions('undo');
        },
        redo() {
            this.fetchAndProcessRevisions('redo');
        },
        addKeyListeners() {
            document.addEventListener('keydown', (event) => {
                if (event.ctrlKey && event.key === 'z') {
                    this.debouncedUndo();
                } else if (event.ctrlKey && event.key === 'y') {
                    this.debouncedRedo();
                }
            });
        },
    },

    beforeDestroy() {
        this.$root.$off('cookieBarHeight', this.setCookieBarHeight);
    },

    created() {
        // Registered in created: the cookie bar is a child and reports its height when it mounts.
        this.$root.$on('cookieBarHeight', this.setCookieBarHeight);
        this.debouncedUndo = debounce(this.undo, 300);
        this.debouncedRedo = debounce(this.redo, 300);
        window.addEventListener("message", (event) => {
            if (!event.data) {
                return;
            }

            if (event.data.action == 'setEditComponent') {
                let found;

                let findComponentConfigById = function(x, id) {
                    if (Array.isArray(x)) {
                        x.forEach(c => {
                            findComponentConfigById(c, id);
                        });
                    } else if (x) {
                        if (x.id == id) {
                            found = x;
                        } else if (typeof x === 'object') {
                            Object.values(x).forEach(c => {
                                findComponentConfigById(c, id);
                            })
                        }
                    }
                };

                console.log('Got Postmessage of setEditComponent for id ' + event.data.data)

                findComponentConfigById(this.$root.siteconfig, event.data.data)
                console.log(found)

                if (found) {
                    this.$store.dispatch('setEditComponentConfig', {config: found, parentComponent: null});
                }
            } else if (event.data.action == 'setRoute') {
                this.$root.followLink(event.data.data);
            } else if (event.data.action == 'setSiteConfig' && event.source == window.top) {
                merge(this.$root.siteconfig, event.data.data);
            }
        });

        if (this.$root.edit) {
            this.addKeyListeners();
        }
    }
};

</script>
